export default __webpack_public_path__ + "95652f831445f5b5b2a2464260b41ea7.png";